import { cardItems } from "@/mocks/homeData";

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            编辑团队为你甄选的优质影视内容与平台动态
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.slice(0, 3).map((card) => (
            <div
              key={card.id}
              className="bg-background-50 rounded-xl overflow-hidden cursor-pointer group border border-background-200/60 hover:border-primary-200 transition-all"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-2.5 py-0.5 rounded text-[10px] font-semibold bg-accent-100 text-accent-700 font-label">
                    {card.tag}
                  </span>
                  <span className="text-[11px] text-foreground-400">{card.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {card.excerpt}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cardItems.slice(3).map((card) => (
            <div
              key={card.id}
              className="bg-background-50 rounded-xl overflow-hidden cursor-pointer group border border-background-200/60 hover:border-primary-200 transition-all flex flex-col sm:flex-row"
            >
              <div className="sm:w-[200px] aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex-1 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2.5 py-0.5 rounded text-[10px] font-semibold bg-secondary-100 text-secondary-700 font-label">
                    {card.tag}
                  </span>
                  <span className="text-[11px] text-foreground-400">{card.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {card.excerpt}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}